@if (loading) {
  <div class="idv-loading-background">
    <spinner></spinner>
  </div>
} @else {
  <div class="routed-component-layout">
    <div class="routed-component-body">
      <div class="routed-component-title-block">
        <h2>{{ "REGISTRATION.STATIC_PRE_IDV_PAGE.TITLE" | translate }}</h2>
        <div class="image docuploadimage"></div>
      </div>

      <p [innerHTML]="'REGISTRATION.STATIC_PRE_IDV_PAGE.PARAGRAPH_1' | translate"></p>

      <div>
        <span [innerHTML]="'REGISTRATION.STATIC_PRE_IDV_PAGE.NECESSARY_STEPS.INTRO' | translate"></span>
        <ul>
          <li *ngFor="let step of necessaryIdvSteps" [innerHTML]="'REGISTRATION.STATIC_PRE_IDV_PAGE.NECESSARY_STEPS.' + step | translate"></li>
        </ul>
      </div>

      <div class="navigation-controls-layout">
        <div class="idv-cta-section">
          <button
            data-cy="IDV_Button_VerifyYourIdentityButton"
            class="primary centered"
            (click)="proceedToIDV()">
            {{ "REGISTRATION.STATIC_PRE_IDV_PAGE.CTA" | translate }}
          </button>
        </div>
      </div>

      <p [innerHTML]="'REGISTRATION.STATIC_PRE_IDV_PAGE.HELP_PARAGRAPH' | translate : {idvHelpPageUrl : idvHelpPageUrl, privacyPolicyLink : privacyPolicyLink }"></p>

    </div>
  </div>
}